import {useEffect} from "react";
import {site} from "./data/site";

function usePageTitle(title) {
    useEffect(() => {
        document.title = title ? `${title} | ${site.name}` : `${site.name} | Custom Doors, Windows & Joinery`;
    }, [title]);
}

export default usePageTitle;
